import React, { useState } from "react";
import { Table2, ChevronDown, ChevronRight } from "lucide-react";

export default function SchemaSidebar({ schema }) {
  const [open, setOpen] = useState({});
  if (!schema) return null;
  return (
    <div className="space-y-1" data-testid="sql-schema-sidebar">
      {Object.entries(schema).map(([table, columns]) => (
        <div key={table}>
          <button
            onClick={() => setOpen((p) => ({ ...p, [table]: !p[table] }))} data-testid={`sql-schema-table-${table}`}
            className="w-full flex items-center gap-2 text-sm text-slate-300 hover:text-white px-2 py-1.5 rounded-lg hover:bg-white/5"
          >
            {open[table] ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
            <Table2 className="w-3.5 h-3.5 text-indigo-400" /> {table}
          </button>
          {open[table] && (
            <div className="pl-9 pb-1">
              {columns.map((c) => (
                <p key={c.name} className="text-xs text-slate-400 py-0.5">{c.name} <span className="text-slate-400">({c.type})</span></p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
